//----- CURRENT LOCATION ON ROUTE POLYLINE --------------------------------------------------------------------------------------------------------------------------------------------
const BLUE_SOLID_POLYLINE_DEFAULTS = {
  strokeColor: '#0072CE',
  strokeOpacity: 1,
  strokeWeight: 8,
  zIndex: 2
};

const RED_SOLID_POLYLINE_DEFAULTS = {
  strokeColor: '#D10002',
  strokeOpacity: 1,
  strokeWeight: 8,
  zIndex: 2
};

const BORDER_POLYLINE_DEFAULTS = {
  strokeColor: '#FFFFFF',
  strokeOpacity: 1,
  strokeWeight: 14,
  zIndex: 1
};

export const BLUE_SOLID_POLYLINE = (overrides = {}): google.maps.PolylineOptions => ({
  ...BLUE_SOLID_POLYLINE_DEFAULTS,
  ...overrides
});

export const RED_SOLID_POLYLINE = (overrides = {}): google.maps.PolylineOptions => ({
  ...RED_SOLID_POLYLINE_DEFAULTS,
  ...overrides
});

export const BORDER_POLYLINE = (overrides = {}): google.maps.PolylineOptions => ({
  ...BORDER_POLYLINE_DEFAULTS,
  ...overrides
});

//----- REMAON ROUTE POLYLINE --------------------------------------------------------------------------------------------------------------------------------------------
const DOTTED_POLYLINE_DEFAULTS = {
  scale: 6,
  fillColor: '#108C78',
  fillOpacity: 1,
  strokeColor: '#FFFFFF',
  strokeOpacity: 1,
  strokeWeight: 2,
}

export const DOTTED_POLYLINE = (overrides = {}): google.maps.PolylineOptions => ({
  strokeOpacity: 0,
  icons: [
    {
      icon: {
        path: google.maps.SymbolPath.CIRCLE,
        ...DOTTED_POLYLINE_DEFAULTS,
        ...overrides
      },
      offset: '0',
      repeat: '12px'
    }
  ]
});